export enum FileContentType {
  Attachment = 0,
  Signature = 1,
  Coaching = 2,
  Warning = 3,
  Disciplinary = 4,
  Termination = 5,
  OnBoarding = 6,

  //Dispute Attachments
  HOS = 10,
  GPSTrail = 11,
  Settlement = 12,
  WeatherMap = 13,

  //Company
  Letterhead = 20,

  //Truck
  TractorFile = 30,
  COI = 31,
  FederalAnnualInspection = 32,
  CabCard = 33,
  MMR = 34,
  IVMR = 35,

  //Employee
  CDL = 40,
  CDLBack = 41,
  MedicalCard = 42,
  MedicalCardBack = 43,

  //Logs
  HosLog = 100,

  //Pre-PostTrip
  TractorLockingJaw = 1016,
  Trailer1Connections = 1000,
  Trailer1Defects = 1010,
  Trailer2Connections = 1001,
  Trailer2PinHook = 1017,
  Trailer2LockingJaw = 1025,
  Trailer2Defects = 1011,
  Trailer3PinHook = 1018,
  Trailer3LockingJaw = 1026,
  Trailer3Connections = 1002,
  Trailer3Defects = 1012,
  ReturnTractorLockingJaw = 1019,
  ReturnTrailer1Connections = 1003,
  ReturnTrailer1Defects = 1013,
  ReturnTrailer2PinHook = 1021,
  ReturnTrailer2LockingJaw = 1027,
  ReturnTrailer2Connections = 1004,
  ReturnTrailer2Defects = 1014,
  ReturnTrailer3PinHook = 1022,
  ReturnTrailer3LockingJaw = 1028,
  ReturnTrailer3Connections = 1005,
  ReturnTrailer3Defects = 1015,
  TractorDamage = 1020,
  HookSlip = 1023,
  DVIR = 1024,
  //last used is 1028
  Trailer1DockDoor = 1029,
  Trailer2DockDoor = 1030,
  Trailer3DockDoor = 1031,
  ReturnTrailer1DockDoor = 1032,
  ReturnTrailer2DockDoor = 1033,
  ReturnTrailer3DockDoor = 1034,
  //Locking Pin for Tractor and Trailers
  TractorLockingJawPin = 1035,
  Trailer2LockingJawPin = 1036,
  Trailer3LockingJawPin = 1037,
  ReturnTractorLockingJawPin = 1038,
  ReturnTrailer2LockingJawPin = 1039,
  ReturnTrailer3LockingJawPin = 1040
}

//TODO move below to EBO Models

export const FileContentTypeMapping: Record<FileContentType, string> = {
  [FileContentType.Attachment]: 'Attachment',
  [FileContentType.Signature]: 'Signature',
  [FileContentType.Coaching]: 'Coaching',
  [FileContentType.Warning]: 'Warning',
  [FileContentType.Disciplinary]: 'Disciplinary',
  [FileContentType.Termination]: 'Termination',
  [FileContentType.OnBoarding]: 'On Boarding',
  [FileContentType.HOS]: 'Hour of Service',
  [FileContentType.GPSTrail]: 'GPS Trail',
  [FileContentType.Settlement]: 'Settlement',
  [FileContentType.WeatherMap]: 'Weather Map',
  [FileContentType.Letterhead]: 'Letter Head',
  [FileContentType.TractorFile]: 'Tractor File',
  [FileContentType.COI]: 'COI - Cert. of Insur.',
  [FileContentType.FederalAnnualInspection]: 'Federal Annual Inspection',
  [FileContentType.CabCard]: 'CAB Card',
  [FileContentType.MMR]: 'MMR',
  [FileContentType.IVMR]: 'IVMR',
  [FileContentType.CDL]: 'CDL',
  [FileContentType.CDLBack]: 'CDL (Back)',
  [FileContentType.MedicalCard]: 'Medical Card',
  [FileContentType.MedicalCardBack]: 'Medical Card (Back)',
  [FileContentType.HosLog]: 'HOS Log',
  [FileContentType.Trailer1Connections]: 'Trailer 1 Connections',
  [FileContentType.Trailer2Connections]: 'Trailer 2 Connections',
  [FileContentType.Trailer3Connections]: 'Trailer 3 Connections',
  [FileContentType.ReturnTrailer1Connections]: 'Return Trailer 1 Connections',
  [FileContentType.ReturnTrailer2Connections]: 'Return Trailer 2 Connections',
  [FileContentType.ReturnTrailer3Connections]: 'Return Trailer 3 Connections',
  [FileContentType.Trailer1Defects]: 'Trailer 1 Defects',
  [FileContentType.Trailer2Defects]: 'Trailer 2 Defects',
  [FileContentType.Trailer3Defects]: 'Trailer 3 Defects',
  [FileContentType.ReturnTrailer1Defects]: 'Return Trailer 1 Defects',
  [FileContentType.ReturnTrailer2Defects]: 'Return Trailer 2 Defects',
  [FileContentType.ReturnTrailer3Defects]: 'Return Trailer 3 Defects',
  [FileContentType.TractorDamage]: 'Tractor Damage',
  [FileContentType.TractorLockingJaw]: 'Tractor Locking Jaw or Pin Hook',
  [FileContentType.Trailer2PinHook]: 'Trailer 2 Pin Hook',
  [FileContentType.Trailer3PinHook]: 'Trailer 3 Pin Hook',
  [FileContentType.ReturnTractorLockingJaw]: 'Return Locking Jaw or Pin Hook',
  [FileContentType.ReturnTrailer2PinHook]: 'Return Trailer 2 Pin Hook',
  [FileContentType.ReturnTrailer3PinHook]: 'Return Trailer 3 Pin Hook',
  [FileContentType.HookSlip]: 'Hook Slip',
  [FileContentType.DVIR]: 'Driver Vehicle Inspection Report',
  [FileContentType.Trailer2LockingJaw]: 'Trailer 2 Locking Jaw',
  [FileContentType.Trailer3LockingJaw]: 'Trailer 3 Locking Jaw',
  [FileContentType.ReturnTrailer2LockingJaw]: 'Return Trailer 2 Locking Jaw',
  [FileContentType.ReturnTrailer3LockingJaw]: 'Return Trailer 3 Locking Jaw',
  [FileContentType.Trailer1DockDoor]: 'Trailer 1 Dock Door',
  [FileContentType.Trailer2DockDoor]: 'Trailer 2 Dock Door',
  [FileContentType.Trailer3DockDoor]: 'Trailer 3 Dock Door',
  [FileContentType.ReturnTrailer1DockDoor]: 'Return Trailer 1 Dock Door',
  [FileContentType.ReturnTrailer2DockDoor]: 'Return Trailer 2 Dock Door',
  [FileContentType.ReturnTrailer3DockDoor]: 'Return Trailer 3 Dock Door',
  [FileContentType.TractorLockingJawPin]: 'Tractor Locking Jaw Pin/Bolt',
  [FileContentType.Trailer2LockingJawPin]: 'Trailer 2 Locking Jaw Pin/Bolt',
  [FileContentType.Trailer3LockingJawPin]: 'Trailer 3 Locking Jaw Pin/Bolt',
  [FileContentType.ReturnTractorLockingJawPin]: 'Return Locking Jaw Pin/Bolt',
  [FileContentType.ReturnTrailer2LockingJawPin]: 'Return Trailer 2 Locking Jaw Pin/Bolt',
  [FileContentType.ReturnTrailer3LockingJawPin]: 'Return Trailer 3 Locking Jaw Pin/Bolt'
};

export const FileContentTypeAsk: FileContentType[] = [
  FileContentType.Attachment,
  FileContentType.HosLog,
  FileContentType.Trailer1Connections,
  FileContentType.Trailer2Connections,
  FileContentType.Trailer3Connections,
  FileContentType.ReturnTrailer1Connections,
  FileContentType.ReturnTrailer2Connections,
  FileContentType.ReturnTrailer3Connections,
  FileContentType.Trailer1Defects,
  FileContentType.Trailer2Defects,
  FileContentType.Trailer3Defects,
  FileContentType.ReturnTrailer1Defects,
  FileContentType.ReturnTrailer2Defects,
  FileContentType.ReturnTrailer3Defects,
  FileContentType.TractorDamage,
  FileContentType.TractorLockingJaw,
  FileContentType.TractorLockingJawPin,
  FileContentType.Trailer2PinHook,
  FileContentType.Trailer3PinHook,
  FileContentType.ReturnTractorLockingJaw,
  FileContentType.ReturnTractorLockingJawPin,
  FileContentType.ReturnTrailer2PinHook,
  FileContentType.ReturnTrailer3PinHook,
  FileContentType.HookSlip,
  FileContentType.DVIR,
  FileContentType.Trailer2LockingJaw,
  FileContentType.Trailer2LockingJawPin,
  FileContentType.Trailer3LockingJaw,
  FileContentType.Trailer3LockingJawPin,
  FileContentType.ReturnTrailer2LockingJaw,
  FileContentType.ReturnTrailer2LockingJawPin,
  FileContentType.ReturnTrailer3LockingJaw,
  FileContentType.ReturnTrailer3LockingJawPin,
  FileContentType.Trailer1DockDoor,
  FileContentType.Trailer2DockDoor,
  FileContentType.Trailer3DockDoor,
  FileContentType.ReturnTrailer1DockDoor,
  FileContentType.ReturnTrailer2DockDoor,
  FileContentType.ReturnTrailer3DockDoor
];

export const FileContentTypeCompany: FileContentType[] = [FileContentType.Attachment, FileContentType.Letterhead];

export const FileContentTypeEmployees: FileContentType[] = [
  FileContentType.Attachment,
  FileContentType.Signature,
  FileContentType.Coaching,
  FileContentType.Warning,
  FileContentType.Disciplinary,
  FileContentType.Termination,
  FileContentType.OnBoarding,
  FileContentType.CDL,
  FileContentType.CDLBack,
  FileContentType.MedicalCard,
  FileContentType.MedicalCardBack
];

export const FileContentTypeTruck: FileContentType[] = [
  FileContentType.Attachment,
  FileContentType.TractorFile,
  FileContentType.COI,
  FileContentType.FederalAnnualInspection,
  FileContentType.CabCard,
  FileContentType.MMR,
  FileContentType.IVMR
];

export const FileContentTypeMaintEvent: FileContentType[] = [FileContentType.Attachment];

export const FileContentTypeDispute: FileContentType[] = [
  FileContentType.Settlement,
  FileContentType.HOS,
  FileContentType.GPSTrail,
  FileContentType.Attachment,
  FileContentType.WeatherMap
];

export const FileContentTypeExpense: FileContentType[] = [FileContentType.Attachment];
